import React from 'react';
import Section from './layouts/Section';
import BlogArea from './layouts/BlogArea';
import PageLayout from './layouts/PageLayout';

const Blog = () => {
  return (
    <PageLayout
      title="Phone Repair Blog | Tips, Guides & News | Cell Station"
      description="Expert phone repair tips, cost guides, and how-to articles from Cell Station's certified technicians in Willow Grove, PA."
      url="https://www.icellstation.com/blog"
    >
      <Section title="Blog">
        <BlogArea />
      </Section>
    </PageLayout>
  );
};

export default Blog;
